import { getActivtyList } from '@/api/config/activity-cfg'

export default {
  props: {
    actArr: {
      type: Array,
      required: true,
      default: () => []
    },
    dateRange: {
      type: Object,
      required: true,
      default: () => ({})
    },
    actNameMap: {
      type: Object,
      required: true,
      default: () => ({})
    },
    hasMoreAct: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actPageIndex: 1,
      actPageSize: 10,
      actTotal: 0,
      actLoading: false
    }
  },
  mounted() {
    this.loadActList()
  },
  methods: {
    loadActList() {
      if (this.actArr && this.actArr.length > 0) return
      const params = { type: 'time_limited_card' }
      getActivtyList(params).then(res => {
        this.actTotal = res.data.count || 0
        this.processActList(res.data.list || [])
      })
    },
    handleVisibleChange(visible) {
      if (visible && this.hasMoreAct && !this.actLoading) {
        this.loadMoreAct()
      }
    },
    loadMoreAct() {
      if (this.actLoading) return
      this.actLoading = true
      this.actPageIndex++
      const params = { type: 'time_limited_card', pageIndex: this.actPageIndex, pageSize: this.actPageSize }
      getActivtyList(params).then(res => {
        this.actLoading = false
        this.processActList(res.data.list || [])
      }).catch(() => {
        this.actLoading = false
      })
    },
    processActList(list) {
      list.forEach(item => {
        if (this.actArr.some(act => act.value === item.id)) return
        const dateRange = item.start_time + '至' + item.end_time
        this.actArr.push({ label: dateRange, value: item.id })
        this.dateRange[item.id] = dateRange
        this.actNameMap[item.id] = `${item.imgNameStr}(${item.id})`
      })
    }
  }
}
